<template>
  <v-container>
    <v-row justify="center" align="center">
      <v-col cols="12">
        <w-main-title
            class="pb-0"
            title="Mis Citas"
            :breadcrumbs="breadcrumbs"
        ></w-main-title>
      </v-col>
      <v-col cols="12">
        <v-sheet class="pa-4 kim-card secondary-card">
          <v-row align="center">
            <v-col cols="12" md="10" class="text-right">
              <v-select
                  :style="`${!isMobile ? 'max-width: 300px; margin-left: auto' : ''}`"
                  outlined
                  hide-details
                  dense
                  label="Estado de la Cita"
                  :items="states"
                  item-text="text"
                  item-value="value"
                  v-model="state"
                  @click:clear="clear"
                  clearable
              />
            </v-col>
            <v-col cols="12" md="2" class="text-right">
              <v-btn
                  width="100%"
                  :height="40"
                   color="primary" small
                  @click="applyFilters" :loading="consulting">
                Aplicar Filtro
              </v-btn>
            </v-col>
          </v-row>
        </v-sheet>
      </v-col>
      <v-flex xs12 v-if="loading">
        <div class="text-center">
          <v-progress-circular
              indeterminate
              color="primary"
              width="2"
          ></v-progress-circular>
        </div>
      </v-flex>
      <v-flex xs12 v-else>
        <v-container grid-list-md>
          <v-layout row wrap v-if="appointments.length === 0">
            <v-flex xs12 class="text-center">
              <h3 class="font-weight-light">No hay Citas en Agenda</h3>
            </v-flex>
          </v-layout>
          <v-row row wrap>
            <v-col cols="12" md="6" lg="4" xl="3" v-for="appointment in appointments" :key="appointment.id">
              <user-appointment-single
                  :appointment="appointment"
                  @click:cancel="cancel"
                  @click:confirm="confirm"
              />
            </v-col>
            <v-flex xs12>
              <item-counter
                  :length="appointments.length"
                  :total="totalItems"
              ></item-counter>
              <next-page-btn
                  :loading="consulting"
                  v-if="nextPageUrl"
                  :nextFn="loadNextPage"
              ></next-page-btn>
            </v-flex>
          </v-row>
        </v-container>
        <kimsa-confirm
            ref="confirmDialog"
            title="Confirmar Cita"
            content="¿Confirmas que asistiras a esta cita?"
            :close-on-confirm="false"
            :loading="confirmLoading"
            @confirm="confirmAppointment"
          />
        <cancel-appointment for-client ref="cancelAppointment" @success="cancelSuccess"/>
      </v-flex>
    </v-row>
  </v-container>

</template>
<script>
import { ApiUtils } from '@/utils/ApiUtils'
import WMainTitle from '@/components/common/WMainTitle'
import { queryFilterBuilder } from '@/utils/Shared'
import UserAppointmentSingle from "@/components/panel-data/UserAppointmentSingle";
import CancelAppointment from "@/components/appointments/CancelAppointment";
import KimsaConfirm from "@/components/common/KimsaConfirm";

export default {
  components: {
    KimsaConfirm,
    CancelAppointment,
    UserAppointmentSingle,
    WMainTitle,
    NextPageBtn: () => import('@/components/common/NextPageBtn'),
    ItemCounter: () => import('@/components/common/ItemCounter')
  },
  data() {
    return {
      breadcrumbs: [
        {
          text: 'Agenda',
          disabled: true,
          href: ''
        }
      ],
      appointments: [],
      appointmentToConfirm: null,
      nextPageUrl: null,
      totalItems: null,
      loading: false,
      confirmLoading: false,
      consulting: false,
      state: null,
      states: [
        { value: null, text: 'Todas' },
        { value: 1, text: 'Citas Confirmadas' },
        { value: 0, text: 'Citas por Confirmar' }
      ]
    }
  },
  async mounted() {
    try {
      this.loading = true
      this.appointments = await this.getAppointments()
    } catch (error) {
      this.toast('Error cargando citas', 'error')
    } finally {
      this.loading = false
    }
  },
  methods: {
    cancel(appointment) {
      const vm = this
      vm.$refs.cancelAppointment.show(appointment.id)
    },
    async cancelSuccess() {
      const vm = this
      vm.$refs.cancelAppointment.hide()
      this.appointments = await this.getAppointments()
    },
    confirm(appointment) {
      const vm = this
      vm.appointmentToConfirm = appointment
      vm.$refs.confirmDialog.show()
    },
    async confirmAppointment(){
      const vm = this
      if(!vm.appointmentToConfirm) return
      vm.confirmLoading = true
      const response = await ApiUtils.makePost(`appointments/${vm.appointmentToConfirm.id}/confirm`)

      if(!response.ok){
        const json = await response.json()
        vm.toast(`Error confirmando cita: ${json.message}`, 'error')
        vm.confirmLoading = false
        return
      }
      vm.appointmentToConfirm = null
      this.appointments = await this.getAppointments()
      vm.confirmLoading = false
      vm.toast('Cita confirmada', 'success')
      vm.$refs.confirmDialog.hide()
    },
    async clear() {
      this.appointments = await this.getAppointments()
    },
    async getAppointments(url = 'appointments') {
      // const url = 'appointments'
      const response = await ApiUtils.makeGet(url)
      const json = await response.json()
      if (response.ok) {
        const d = json.result.appointments
        this.totalItems = d.total
        this.nextPageUrl = d.next_page_url
        return d.data
      }
      return []
    },
    async applyFilters() {
      const filters = {
        confirmed: this.state,
      }
      const query = queryFilterBuilder(filters)
      this.consulting = true
      let url = 'appointments'
      if (query.ok)
        url = `appointments?${query.query}`
      this.appointments =  await this.getAppointments(url)
      this.consulting = false
    },
    async loadNextPage() {
      if (!this.nextPageUrl) return
      try {
        this.consulting = true
        const newAppointments = await this.getAppointments(this.nextPageUrl.split('/v1/')[1])
        this.appointments = [...this.appointments, ...newAppointments]
      } catch (error) {
        this.toast('Error cargando citas', 'error')
      } finally {
        this.consulting = false
      }
    }
  }
}
</script>
